// extracted by mini-css-extract-plugin
export default {"button":"ModerateCardDetailsContainer-button-d246dff9dcef8f297e5285fc7c213015"};